/**
 * Romanian Tax Engine - Investment Tax Calculator
 * MoneySmart.ro - Plan Acumulare, Viitorul Copilului, Cont Economii, Credit
 */

export const INVESTMENT_TYPES = {
  SAVINGS_ACCOUNT: 'savings_account',
  ACCUMULATION_PLAN: 'accumulation_plan',
  CHILD_FUTURE: 'child_future',
  CREDIT: 'credit',
};

export const TAX_RULES = {
  [INVESTMENT_TYPES.SAVINGS_ACCOUNT]: {
    interestTaxRate: 10,
    taxOnEachPeriod: true,
    useSimpleInterest: true,
    hasAdminFee: false,
    description: { ro: 'Dobândă simplă, impozit 10% pe dobândă', en: 'Simple interest, 10% tax on interest' },
  },
  [INVESTMENT_TYPES.ACCUMULATION_PLAN]: {
    interestTaxRate: 0,
    taxOnEachPeriod: false,
    useSimpleInterest: false,
    hasAdminFee: true,
    defaultAdminFee: 1.5,
    description: { ro: 'Dobândă compusă, fără taxare anuală în acumulare', en: 'Compound interest, no annual tax during accumulation' },
    warning: { ro: 'Comisionul administrativ poate varia în funcție de contract', en: 'Administrative fee may vary depending on contract' },
  },
  [INVESTMENT_TYPES.CHILD_FUTURE]: {
    interestTaxRate: 0,
    taxOnEachPeriod: false,
    useSimpleInterest: false,
    hasAdminFee: true,
    defaultAdminFee: 1.5,
    description: { ro: 'Plan de economisire pentru copil, dobândă compusă', en: 'Child savings plan, compound interest' },
  },
  [INVESTMENT_TYPES.CREDIT]: {
    interestTaxRate: 0,
    taxOnEachPeriod: false,
    useSimpleInterest: false,
    hasAdminFee: false,
    description: { ro: 'Calculator credit ipotecar / consum', en: 'Mortgage / consumer loan calculator' },
  },
};

export const getTaxConfig = (investmentType) => {
  return TAX_RULES[investmentType] || TAX_RULES[INVESTMENT_TYPES.ACCUMULATION_PLAN];
};

export const getInvestmentTypeLabels = (language = 'ro') => {
  const labels = {
    [INVESTMENT_TYPES.SAVINGS_ACCOUNT]: {
      ro: 'Cont de economii',
      en: 'Savings Account',
      icon: '🏦',
    },
    [INVESTMENT_TYPES.ACCUMULATION_PLAN]: {
      ro: 'Simulator plan de acumulare',
      en: 'Accumulation Plan Simulator',
      icon: '📈',
    },
    [INVESTMENT_TYPES.CHILD_FUTURE]: {
      ro: 'Viitorul Copilului',
      en: "Child's Future Plan",
      icon: '👶',
    },
    [INVESTMENT_TYPES.CREDIT]: {
      ro: 'Simulator Credit',
      en: 'Loan Simulator',
      icon: '🏠',
    },
  };

  return Object.entries(labels).map(([value, label]) => ({
    value,
    label: label[language],
    icon: label.icon,
    description: TAX_RULES[value]?.description?.[language] || '',
    warning: TAX_RULES[value]?.warning?.[language] || null,
    hasAdminFee: TAX_RULES[value]?.hasAdminFee || false,
    useSimpleInterest: TAX_RULES[value]?.useSimpleInterest || false,
  }));
};
